import React, { useState } from 'react';
import usePredictedGrade from '../../hooks/usePredictedGrade';
import theme from '../../theme';
import Icon from './Icons';

// Shows a predicted grade with its basis always one hover/tap away — never an
// unexplained number. trend is optional: { delta, direction: 'up'|'down' }.
// Pass label="" for a compact inline variant (used in per-subject mini rows).
export default function PredictedGrade({ subjectId, label = 'Predicted grade', trend, size = 'md' }) {
  const [showTip, setShowTip] = useState(false);
  const { grade, pct, basis, hasData, lowBasis } = usePredictedGrade(subjectId);
  const compact = !label;
  const big = size === 'lg';

  if (!hasData) {
    return (
      <div style={{ fontSize: '11.5px', color: theme.textTertiary, fontStyle: 'italic' }}>
        {compact ? 'No data yet' : 'Rate a few subtopics to see this.'}
      </div>
    );
  }

  return (
    <div style={{ position: 'relative' }}>
      {!compact && (
        <div style={{ display: 'flex', alignItems: 'baseline', gap: '8px' }}>
          <span style={{ fontSize: big ? '11.5px' : '11px', fontWeight: 700, color: theme.textTertiary, textTransform: 'uppercase', letterSpacing: '0.06em' }}>{label}</span>
          <button
            onMouseEnter={() => setShowTip(true)} onMouseLeave={() => setShowTip(false)}
            onClick={() => setShowTip(s => !s)}
            aria-label="How is this calculated?"
            style={{ background: 'none', border: 'none', cursor: 'pointer', color: theme.textTertiary, padding: 0, display: 'flex' }}>
            <Icon name="sparkle" size={12} />
          </button>
        </div>
      )}
      <div style={{ display: 'flex', alignItems: 'baseline', gap: compact ? '6px' : '10px', marginTop: compact ? 0 : '4px' }}>
        <span style={{ fontSize: big ? '34px' : compact ? '15px' : '22px', fontWeight: 800, letterSpacing: '-0.02em', color: theme.text }}>{grade}</span>
        {!compact && <span style={{ fontSize: '12.5px', color: theme.textTertiary }}>{pct}% basis</span>}
        {trend && (
          <span style={{ fontSize: '11px', fontWeight: 700, color: trend.direction === 'up' ? theme.green : theme.red, display: 'flex', alignItems: 'center', gap: '2px' }}>
            <Icon name={trend.direction === 'up' ? 'trendUp' : 'trendDown'} size={11} />
            {trend.delta}pt
          </span>
        )}
        {compact && (
          <button
            onMouseEnter={() => setShowTip(true)} onMouseLeave={() => setShowTip(false)}
            onClick={() => setShowTip(s => !s)}
            aria-label="How is this calculated?"
            style={{ background: 'none', border: 'none', cursor: 'pointer', color: theme.textTertiary, padding: 0, display: 'flex' }}>
            <Icon name="sparkle" size={11} />
          </button>
        )}
      </div>
      {lowBasis && !compact && (
        <div style={{ fontSize: '11px', color: theme.amber, marginTop: '4px', fontWeight: 600 }}>
          Complete more topics for a reliable prediction.
        </div>
      )}
      {showTip && (
        <div style={{
          position: 'absolute', top: '100%', right: compact ? 0 : 'auto', left: compact ? 'auto' : 0, marginTop: '8px', width: '240px', zIndex: 20,
          padding: '12px 14px', borderRadius: theme.radius.md, backgroundColor: theme.text, color: theme.bg,
          fontSize: '12px', lineHeight: 1.5, boxShadow: theme.shadow.lg,
        }}>
          {basis}
        </div>
      )}
    </div>
  );
}
